import React, {useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import {Form, InputGroup, OverlayTrigger, Tooltip} from "react-bootstrap";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";



function GamesListRowVideo(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'gamesListRowVideos' });
    const [linkCopied, setLinkCopied] = useState(false)

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    function prepDate(label) {
        let initialValArray = label.split("-")
        let date = initialValArray.slice(0, 3).join(".")
        let time = initialValArray.slice(3).join(":")
        return date + " " + time
    }

    function copyUrlToClipboard(event) {
        navigator.clipboard.writeText(props.video.url);
        setLinkCopied(true)
        trySetTimeout(() => {
            setLinkCopied(false)
        }, 5000)

        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    return <div className={cabinetStyle.tileVideo}>
        <Form.Label>{props.user_title}</Form.Label>
        <InputGroup.Text style={{
            backgroundColor: '#DEE2E6',
            marginBottom: "8px",
            maxWidth: "200px",
            borderRadius: "8px",
            justifyContent: "space-evenly"
        }}>{prepDate(props.video.label)}</InputGroup.Text>
        <InputGroup.Text
            style={{
                backgroundColor: '#DEE2E6',
                marginBottom: "8px",
                maxWidth: "200px",
                borderRadius: "8px",
                justifyContent: "space-evenly"
            }}
        >
            <a href={props.video.url} download target="_blank">{t('download')}</a>

        </InputGroup.Text>
        <OverlayTrigger
            placement="top"
            delay={{show: 50, hide: 400}}
            overlay={renderTooltip(t('copyLink'))}
        >
            <div className={cabinetStyle.controlsCopySmall}>
                <ContentCopyIcon sx={linkCopied ? {color: '#64dd17'} : {color: '#ede7f6'}}
                                 onClick={copyUrlToClipboard} fontSize="medium"
                ></ContentCopyIcon>
            </div>
        </OverlayTrigger>
    </div>
}

export default GamesListRowVideo